class LikeButton
    constructor: (el) ->
        @.$el = el

        @.count = parseInt @.$el.textContent, 10
        @.liked = @.$el.classList.contains 'icon-like-marked-before'

        @.InitEvents()
        @.$el.classList.add 'like-button--bound'
        return

    InitEvents: ->
        self = @
        @.$el.addEventListener 'click', (e) ->
            self.SetState !self.liked
            self.$el.dispatchEvent new CustomEvent 'like-button-state', {
                bubbles: false,
                detail: {
                    count: self.count
                    liked: self.liked  
                }
            }
            return
        return
    
     SetState: (liked) ->
        if liked
            @.liked = true
            @.count++
            @.$el.textContent = @.count
            @.$el.classList.remove 'icon-like-before'
            @.$el.classList.add 'icon-like-marked-before'
        else
            @.liked = false
            @.count--
            @.$el.textContent = @.count
            @.$el.classList.remove 'icon-like-marked-before'
            @.$el.classList.add 'icon-like-before'
        return

BindLikeButtons = ->
    document.querySelectorAll '.like-button:not(.like-button--bound)'
        .forEach (el) ->
            new LikeButton el
            return
    return

window.addEventListener 'bind-components', BindLikeButtons

class LikeButtonCreate
    constructor: (options) ->
        @.$el = null

        @.attrs = options?.attrs ? false
        @.bindLater = options?.bindLater ? false
        @.count = options?.count ? 0
        @.disabled = options?.disabled ? false
        @.liked = options?.liked ? false
        @.tag = options?.tag ? false

        @.CreateElement()
        if !@.bindLater
            new LikeButton @.$el
        return @.$el

    CreateElement: ->
        @.$el = document.createElement @.tag
        if @.tag == "button"
            @.$el.type = "button"
        if @.attrs
            @.$el = window.appUtils.Attributes @.attrs, @.$el
        if @.disabled
            @.$el.setAttribute 'disabled', ''
        @.$el.classList.add 'like-button', ( if @.liked then 'icon-like-marked-before' else 'icon-like-before')
        @.$el.innerHTML = @.options?.count ? 0
        return

window.CreateLikeButton = (options) ->
    return new LikeButtonCreate options